import { IAdapter } from '@drl/core/api/adapters/i-adapter';
import { ApiService } from '@drl/core/api/api.service';
import { GetAPICommand, GetListAPICommand } from '@drl/core/api/commands';
import { environment } from '@drl/env/environment';

export class GetPrescRefillCompletingPatientsCount<T> extends GetAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(apiService, adapter, `${environment.patientApiUrl}/patients/prescriptions-due/count`);
  }
}

export class GetRxRefillSummaryList<T> extends GetListAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(apiService, adapter, `${environment.patientApiUrl}/patients/prescriptions/refill-summary`);
  }
}

export  class GetRxRefillFiltersCount<T> extends GetAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(apiService, adapter, `${environment.patientApiUrl}/patients/prescriptions-due/filters/count`);
  }
}

export class GetRxTotalCount<T> extends GetAPICommand<T> {  
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(apiService, adapter, `${environment.patientApiUrl}/patients/prescriptions/refill-summary/count`);
  }
}

export class GetPrescriptionCount<T> extends GetAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(apiService, adapter, `${environment.patientApiUrl}/prescriptions/count`);
  }
}


export class GetRefillRate<T> extends GetAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>, id: number) {
    super(apiService, adapter, `${environment.patientApiUrl}/prescriptions/patients/${id}/refill-rate`);
  }
}

export class GetActivePresStatus<T> extends GetAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>, id: number) {
    super(apiService, adapter, `${environment.patientApiUrl}/prescriptions/patients/${id}/active-rx-status`);
  }
}